<div class="quill-editor-container">
    <div #editorContainer class="editor-container"></div>
</div>
  